import Background from './Background';
import Watermark from './Watermark';

export { Watermark };
export default Background;
